import { DatePipe, formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-payment-receipt-register',
  templateUrl: './payment-receipt-register.component.html',
  styleUrl: './payment-receipt-register.component.scss'
})
export class PaymentReceiptRegisterComponent implements OnInit {
  advtBrieflyTotal: number;
 constructor(
    private dialogRef: MatDialogRef<PaymentReceiptRegisterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
  ) {
  }


  advtBrieflyFormBeans: any = []

  reportType:any
  startDate :any
  endDate :any
  repName :any
  offRepName:any
  advtName :any
  issueDates:any
  issueDates1:any

 PaymentReceiptRegister = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    rep_name: new FormControl(),
    off_rep_name: new FormControl(),
    issuename: new FormControl(),
    issueDates:new FormControl(),
  });
  startDate_contract: any;
  enddate_contract: any;
  ngOnInit(): void {

debugger
let repname: any = this.data['repName'];

    // Then check if it's not empty and convert to array
    if (repname != "") {
      repname = repname; // This puts the single value in an array
    }

    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'];
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];

  // const req: any = {
  //  "rep_name":  this.repName,
  //   "start_date": this.startDate,
  //   "end_date": this.endDate,
  //   "off_rep_name": this.offRepName,
  //   "advt_name": this.data['name'],
  //   // // "issue_name" : this.advtName,
  //   // "issue_date": this.issueDates
  //   "issue_name": "",
  //   "issue_date": this.issueDates1


  // }

  const req: any = {
    "rep_name": repname,
    "start_date": this.startDate,
    "end_date": this.endDate,
    "off_rep_name": this.offRepName,
    "advt_name": this.data['name'],
    // // "issue_name" : this.advtName,
    // "issue_date": this.issueDates
    "issue_name": "",
    "issue_date": this.issueDates


  }



   this.service.getAdvtBriefly(req).subscribe((data: any) => {
    console.log("ADVT Brielfy Data=", data);
    this.advtBrieflyFormBeans = (data as any);;

    this.advtBrieflyTotal = 0;
    for (let repData of this.advtBrieflyFormBeans) {
      this.advtBrieflyTotal += parseInt(repData.rcv_amt) || 0;

    }
  });


}

// printPage4() {
//   const printSection = document.getElementById('print-section');
//   if (!printSection) return console.error('Print section not found!');

//   const sectionHTML = printSection.innerHTML;
//   const footerElement = printSection.querySelector('tfoot');
//   const footerHTML = footerElement ? footerElement.outerHTML : '';

//   const screenW = window.screen.availWidth,
//         w = 1200,
//         left = Math.floor((screenW - w) / 2);

//   const win = window.open('', '', `width=${w},height=1000,top=50,left=${left},scrollbars=yes`);
//   if (!win) return console.error('Failed to open print window.');

//   win.document.open();
//   win.document.write(`
// <!DOCTYPE html>
// <html>
// <head>
//   <title>Print Report</title>
//   <style>
//     @media print {
//       @page { size: A3 landscape; margin: 20mm; }
//       body, .print-section, .print-section * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//         box-sizing: border-box !important;
//         margin: 0; padding: 0;
//         font-family: Arial, sans-serif;
//         font-size: 10px !important;
//       }
//       .print-section {
//         width: 100% !important;
//         display: block !important;
//         overflow: visible !important;
//       }
//       table {
//         width: 100% !important;
//         border-collapse: collapse !important;
//         table-layout: auto !important;
//       }
//       th, td {
//         padding: 3px 5px !important;
//         border: 1px solid #000 !important;
//         box-sizing: border-box !important;
//         font-size: 10px !important;
//         word-wrap: break-word;
//       }
//       thead { display: table-header-group; }
//       tfoot { display: table-footer-group; }
//       tr.header-row { display: table-header-group; }
//       .footer-line {
//         position: fixed; bottom: 0; left: 0;
//         width: 100%; height: 2px; background-color: #000 !important;
//       }
//     }
//   </style>
// </head>
// <body>
//   <div class="print-section">
//     ${sectionHTML}
//     ${footerHTML}
//     <div class="footer-line"></div>
//   </div>
//   <script>
//     window.onload = () => {
//       const table = document.querySelector('table');
//       if (!table) return console.error('Table not found');

//       // Move the header row into THEAD
//       let hdrIdx = -1;
//       Array.from(table.rows).slice(0, 10).forEach((r,i) => {
//         const textArr = Array.from(r.cells).map(c => c.textContent.trim());
//         if (r.cells.length >= 8 && ['Invoice No','Receipt No','Balance'].some(k => textArr.includes(k))) {
//           hdrIdx = i;
//         }
//       });
//       if (hdrIdx >= 0) {
//         const thead = table.querySelector('thead') || table.prepend(document.createElement('thead'));
//         thead.appendChild(table.rows[hdrIdx]);
//       }

//       // Duplicate the final total row into <tbody>
//       const footer = document.querySelector('tfoot');
//       if (footer) {
//         const totalRow = footer.querySelector('tr');
//         if (totalRow) {
//           const tbody = table.querySelector('tbody') || table;
//           const dup = totalRow.cloneNode(true);
//           dup.classList.add('tot-row-duplicated');
//           tbody.appendChild(dup);
//         }
//       }

//       // Right-align numeric cells
//       table.querySelectorAll('td').forEach(c => {
//         if (/^-?\\d+[\\d,]*(\\.\\d+)?$/.test(c.textContent.trim())) {
//           c.style.textAlign = 'right';
//         }
//       });

//       setTimeout(() => {
//         win.print();
//         setTimeout(() => win.close(), 300);
//       }, 200);
//     };
//   </script>
// </body>
// </html>`);
//   win.document.close();
// }
show = false;
// printPageA4() {
//   this.show = true;
//   const printSection = document.getElementById('print-section');
//   if (!printSection) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printContent = printSection.innerHTML;
//   const screenWidth = window.screen.availWidth;
//   const windowWidth = 1000;
//   const leftPosition = screenWidth - windowWidth - 50;

//   const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);

//   if (printWindow) {
//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             @media print {
//               @page {
//                 size: A4 landscape;
//                 margin: 5mm;
//               }

//               body {
//                 margin: 0;
//                 padding: 0;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }

//               /* Prevent duplicate headers */
//               thead {
//                 display: table-header-group;
//                   // background-color: #e9ecef;
//               }
//               tfoot {
//                 display: table-footer-group;
//               }

//               /* Table styles */
//               table {
//                 border-collapse: collapse;
//                 width: 60% !important;
//                  margin: 0 auto; /* ✅ Centers the table horizontally */
//                 font-size: 10pt;
//                 page-break-inside: auto;
//               }
//                 .table thead th {
//     // background-color: #e9ecef;
//     font-weight: 400;
//     color: #050505ff;
//     text-align: center;
// }

// .table thead tr:first-child th {
//     // background-color: #080808ff;
//     font-size: 16px;
//     font-weight: bold;
//     color: #050505ff;
// }

// .table thead tr:nth-child(2) th {
//     // background-color: #0d0e0dff;
//     font-weight: 600;
//     color: #050505ff;
// }

// .table thead tr:nth-child(3) th,
// .table thead tr:nth-child(4) th {
//     // background-color: #f8f9fa;
//     font-weight: 600;
//     font-size: 14px;
//     color: #050505ff;
// }

// // .table tbody tr {
// //     background-color: #ffffff;
// // }

// // .table tbody tr:nth-child(even) {
// //     background-color: #f8f9fa;
// // }

// // .table tbody tr:hover {
// //     background-color: #e3f2fd;
// // }

// .table tbody td {
//     color: #0a0a0aff;
//     font-size: 13px;
// }

// .table tfoot td {
//     // background-color: #e9ecef;
//     font-weight: bold;
//     color: #0d0d0eff;
//     // border-top: 2px solid #dee2e6;
// }

// .total-row {
//     // background-color: #fff3cd !important;
//     font-weight: bold;
// }

// .total-row td {
//     color: #ddb336ff !important;
//     border-top: 2px solid #ffeaa7;
// }

//               th, td {
//                 border: 1px solid black !important;
//                 padding: 3px 5px !important;
//                 white-space: nowrap;
//                 text-align:left;
//               }

//               /* Ensure no page breaks inside rows */
//               tr {
//                 page-break-inside: avoid;
//                 page-break-after: auto;
//               }

//               /* Scale down if needed */
//               @page :footer {
//                 display: none;
//               }
//               @page :header {
//                 display: none;
//               }

//               /* Hide non-print elements */
//               .noPrint {
//                 display: none !important;
//               }
//             }

//             @media screen {
//               body {
//                 // background-color: #f1f1f1;
//                 margin: 0;
//                 padding: 20px;
//               }
              
//               .print-section {
//                 background: white;
//                 box-shadow: 0 0 5px rgba(0,0,0,0.1);
//                 padding: 20px;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-section">${printContent}</div>
//           <script>
//             window.onload = function() {
//               setTimeout(function() {
//                 window.print();
//                 setTimeout(function() {
//                   window.close();
//                 }, 500);
//               }, 200);
//             };
//           </script>
//         </body>
//       </html>
//     `);

//     printWindow.document.close();
//   } else {
//     console.error("Failed to open print window.");
//   }
// }


// printPageA4() {
//   this.show = true;
//   const printSection = document.getElementById('print-section');
//   if (!printSection) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printContent = printSection.innerHTML;
//   const screenWidth = window.screen.availWidth;
//   const windowWidth = 1000;
//   const leftPosition = screenWidth - windowWidth - 50;

//   const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);

//   if (printWindow) {
//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             @media print {
//               @page {
//                 size: A4 landscape;
//                 margin: 5mm;
//               }

//               body {
//                 margin: 0;
//                 padding: 0;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }

//               thead {
//                 display: table-header-group;
//               }
//               tfoot {
//                 display: table-footer-group;
//               }

//               table {
//                 border-collapse: collapse;
//                 width: 60% !important;
//                 margin: 0 auto;
//                 font-size: 10pt;
//                 page-break-inside: auto;
//               }

//               /* ✅ Make header black with white text */
//               .table thead th {
//                 background-color: #f7f7f7ff !important;
//                 color: #0e0d0dff !important;
//                 font-weight: bold;
//                 text-align: center;
//               }

//               th, td {
//                 border: 1px solid black !important;
//                 padding: 3px 5px !important;
//                 white-space: nowrap;
//                 text-align: left;
//               }

//               tr {
//                 page-break-inside: avoid;
//                 page-break-after: auto;
//               }

//               .noPrint {
//                 display: none !important;
//               }
//             }

//             @media screen {
//               body {
//                 margin: 0;
//                 padding: 20px;
//               }
//               .print-section {
//                 background: white;
//                 box-shadow: 0 0 5px rgba(0,0,0,0.1);
//                 padding: 20px;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-section">${printContent}</div>
//           <script>
//             window.onload = function() {
//               setTimeout(function() {
//                 window.print();
//                 setTimeout(function() {
//                   window.close();
//                 }, 500);
//               }, 200);
//             };
//           </script>
//         </body>
//       </html>
//     `);

//     printWindow.document.close();
//   } else {
//     console.error("Failed to open print window.");
//   }
// }


printPageA4() {
  this.show = true;
  const printSection = document.getElementById('print-section');
  if (!printSection) {
    console.error("Print section not found!");
    return;
  }

  const printContent = printSection.innerHTML;
  const screenWidth = window.screen.availWidth;
  const windowWidth = 1000;
  const leftPosition = screenWidth - windowWidth - 50;

  const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page {
                size: A4 portrait;
                margin: 5mm;
              }

              body {
                margin: 0;
                padding: 0;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              thead {
                display: table-header-group;
              }
              tfoot {
                display: table-footer-group;
              }

              table {
                border-collapse: collapse;
                width: 60% !important;
                margin: 0 auto;
                font-size: 10pt;
                page-break-inside: auto;
              }

              /* ✅ Make header black with white text */
              .table thead th {
                background-color: #f7f7f7ff !important;
                color: #0e0d0dff !important;
                font-weight: bold;
                text-align: center;
              }

              th, td {
                border: 1px solid black !important;
                padding: 3px 5px !important;
                white-space: nowrap;
                text-align: left;
              }

              tr {
                page-break-inside: avoid;
                page-break-after: auto;
              }

              .noPrint {
                display: none !important;
              }
            }

            @media screen {
              body {
                margin: 0;
                padding: 20px;
              }
              .print-section {
                background: white;
                box-shadow: 0 0 5px rgba(0,0,0,0.1);
                padding: 20px;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-section">${printContent}</div>
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                setTimeout(function() {
                  window.close();
                }, 500);
              }, 200);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}




  exportExcel(fileName): void {
  console.log('Export function called with fileName:', fileName);
  
  let element = document.getElementById('print-section');
  console.log('Element found:', element);
  
  if (!element) {
    console.error('Element with ID "print-section" not found in DOM');
    return;
  }
  
  try {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    console.log('Worksheet created:', ws);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    XLSX.writeFile(wb, fileName + '.xlsx');
    console.log('File should be downloaded');
  } catch (error) {
    console.error('Error during export:', error);
  }
}
}
